<template>
  <b-container>
    <Breadcrumbs crumbString="Products,Mountings,General Frames & Mounting"></Breadcrumbs>
    <b-row>
      <b-col class="col-12 col-md-4 col-lg-4">
        <h2>{{ title }}</h2>
        <div>An overview of a broad range of workable interpretive signs and mountings</div><br>
        <div>enviroSIGNS has, over the years, utilized many different methods and ideas for
          mounting interpretive and historical signs. This is a pictorial overview of some possibilities.</div>
        <div><b-btn class="mt-3" @click="createEstimateFromPage">Create an Estimate</b-btn></div>
      </b-col>
      <b-col class="col-12 col-md-8 col-lg-8">
        <b-container class="pods-container">
          <b-row>
            <b-col class="col-12 col-md-6 col-lg-6">
              <b-row>
                <b-col class="col-12 image-pod">
                  <div class="img general-70-img"
                       v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/general-frames/upright-base-weathering-steel.jpg') + ')'}"></div>
                </b-col>
              </b-row>
              <b-row>
                <b-col class="col-12 image-pod">
                  <div class="img general-73-img"
                       v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/general-frames/cast-aluminum-base.jpg') + ')'}"></div>
                </b-col>
              </b-row>
            </b-col>
            <b-col class="col-12 col-md-6 col-lg-6 image-pod">
              <div class="img general-146-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/general-frames/rail-mount-bracket.jpg') + ')'}"></div>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="col-12 col-md-8 col-lg-8 image-pod">
              <div class="img general-49-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/general-frames/stud-mounted-sign.jpg') + ')'}"></div>
            </b-col>
            <b-col class="col-12 col-md-4 col-lg-4 image-pod">
              <div class="img general-100-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/general-frames/custom-powder-coated-aluminum-sign-base.jpg') + ')'}"></div>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="col-12 col-md-3 col-lg-3 image-pod">
              <div class="img general-150-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/general-frames/powder-coated-aluminum-upright-base-with-frame.jpg') + ')'}"></div>
            </b-col>
            <b-col class="col-12 col-md-9 col-lg-9 image-pod">
              <div class="img general-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/general-frames/low-profile-pedestal-posts.jpg') + ')'}"></div>
            </b-col>
          </b-row>
        </b-container>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import Breadcrumbs from '@/components/Breadcrumbs.vue'
  import { createEstimateFromPage } from '@/mixins/createEstimateFromPage'

  export default {
    components: {
      Breadcrumbs
    },
    mixins: [ createEstimateFromPage ],
    data () {
      return {
        title: 'General Frames & Mounting'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/products/GeneralFrames.vue